var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"create"}},[_c('h4',[_vm._v("Do you want to delete this image?")]),_c('div',{attrs:{"id":"buttons"}},[_c('div',{staticClass:"button",attrs:{"id":"btn1"},on:{"click":_vm.del}},[_vm._v("Delete")]),_c('div',{staticClass:"button",attrs:{"id":"btn2"},on:{"click":_vm.cancel}},[_vm._v("Cancel")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }